import styled from 'styled-components';

export const Container = styled.div`
  height: 45px;
  width: 60%;
  display: flex;
  align-items: center;
  align-self: flex-end;
  margin-bottom: 12px;
  padding: 0px 10px;
  position: relative;
  background: #ffffff;
  border: 0.743685px solid #c2c2c2;
  box-sizing: border-box;
  border-radius: 9.01167px;

  svg {
    color: #c2c2c2;
    font-size: 20px;
  }

  .MuiInputBase-root {
    margin-left: 10px;
    height: 100%;
    color: #757575;
    font-size: 14px;
  }

  .MuiButtonBase-root {
    width: 32px;
    height: 32px;
    position: absolute;
    border-radius: 50%;
    right: 10px;
  }
`;
